import RNFS from 'src/lib/RNFS/RNFS'

const basePath = RNFS.DocumentDirectoryPath
export const DevModeEnvPath = `${basePath}/pf_env`
export const DevModeFilePath = `${basePath}/dev_mod`
